<i18n>
{
"en": {
  "INCIDENTS": "Incidents",
  "SUPERVISOR": "Supervisors | Supervisor",
  "DRIVER": "Drivers | Driver",
  "ROUTE": "Route",
  "DIRECTION": "Direction",
  "DATE": "Date",
  "STOP": "# Of Stops",
  "STUDENT": "# Of Students",
  "COMPLETEDTIME": "Completed Time",
  "COUNT": "Count",
  "DATERANGE": "Date Range",
  "BUSNUMBER": "Bus Number",
  "MAKE": "Make",
  "YEAR": "Year",
  "PLATE": "Plate",
  "NATIONALITY": "Nationality",
  "GENDER": "Gender",
  "BUS": "Buses | Bus",
  "INCIDENT": "Incidents",
  "VIOLATION": "Violations",
  "TYPE": "Type",
  "STATUS": "Status",
  "LABEL": "Label",
  "IDEXPIRATION": "ID Expiration",
  "GRADE": "Grade",
  "TEXT": "Text",
  "Lng": "Longitude",
  "Lat": "Latitude",
  "ALARMSTATUS": "Alarm Status",
  "REASON": "Reason",
  "SPEED": "Speed",
  "STUDENTNAME": "Student Name",
  "CLASS": "Class",
  "CAPACITY": "Capacity",
  "EXPIRATIONDATE": "Expiration Date",
  "BYNATIONALITY": "By Nationality",
  "ABSENCE": "Absence",
  "ADDRESS": "Address",
  "ASSIGNEDBUS": "Assigned Bus",
  "OPEN": "Open",
  "REPORTED": "Reported",
  "SICKNESS": "Sickness",
  "VACATION": "Vacation",
  "EMERGENCY": "Emergency",
  "PERSONAL": "Personal",
  "CHILDBEHAVIOUR": "Child Behaviour",
  "MEDICAL": "Medical",
  "DRIVERISSUE": "Driver Issue",
  "BUSPROBLEM": "Bus Problem",
  "ACCIDENT": "Accident",
  "TRAFFIC": "Traffic",
  "CALLPOLICE": "Call Police",
  "CALLSCHOOL": "Call School",
  "OTHER": "Other",
  "SMOKEDETECTED": "Smoke detected",
  "PANICBUTTONPRESSED": "Panic button pressed",
  "HIGHSPEEDALARM": "High speed alarm",
  "REPORT": "Report",
  "GETREPORT": "Get Report",
  "GROUPBY": "Group By",
  "GROUPEDBY": "Grouped By",
  "SELECTALL": "Select All",
  "DESELECTALL": "Deselect All",
  "SHOW": "Show",
  "EXPORT": "Export",
  "TRIPS": "Trips",
  "SELECTROUTE": "Select route",
  "SELECTDIRECTION": "Select direction",
  "HOMETOSCHOOL": "Home To School",
  "SCHOOLTOHOME": "School To Home",
  "PICKARANGE": "Pick a range",
  "NODATATOSHOW": "No data to show",
  "MINCAPACITY": "Min Capacity",
  "MAXCAPACITY": "Max Capacity",
  "MINYEAR": "Min Year",
  "MAXYEAR": "Max Year",
  "PICKADATE": "Pick a date",
  "UNIQUECOUNTBY": "Unique Count By",
  "FILTERBYSUPERVISOR": "Filter By Supervisor",
  "SELECTNATIONALITY": "Select nationality",
  "SELECTBUS": "Select bus",
  "FILTERBYDRIVER": "Filter By Driver",
  "SELECTVIOLATION": "Select violation",
  "FILTERBYINCIDENT": "Filter By Incident",
  "SELECTONE": "Select one",
  "SELECTMULTIPLE": "Select multiple",
  "SELECTDRIVER": "Select driver",
  "SELECTSUPERVISOR": "Select supervisor",
  "SELECTTYPE": "Select type",
  "SELECTSTATUS": "Select status",
  "STUDENTS": "Students",
  "SELECTREASON": "Select reason",
  "SEARCHADDRESS": "Search address",
  "SELECTGRADE": "Select grade",
  "FILTERBYSTUDENT": "Filter By Student",
  "KM": "Km",
  "LOADING": "Loading..."
},
"ar": {
  "INCIDENTS": "حوادث",
  "SUPERVISOR":"المشرفات | مشرفة",
  "DRIVER": "السائقين | سائق",
  "ROUTE":"خط السير",
  "DIRECTION": "اتجاه",
  "DATE": "تاريخ",
  "STOP": "عدد التوقفات",
  "STUDENT": "عدد الطلاب",
  "COMPLETEDTIME": "الوقت المكتمل",
  "COUNT": "إحصاء",
  "DATERANGE": "نطاق التاريخ",
  "BUSNUMBER": "رقم الحافلة",
  "MAKE": "الصنع",
  "YEAR": "السنة",
  "PLATE": "رقم اللوحة",
  "NATIONALITY": "الجنسية",
  "GENDER": "جنس",
  "BUS": "حافلة",
  "INCIDENT": "حوادث",
  "VIOLATION": "انتهاكات",
  "TYPE": "نوع",
  "STATUS": "الحالة",
  "LABEL": " تسمية ",
  "IDEXPIRATION": "انتهاء صلاحية الهوية",
  "GRADE": "الدرجة",
  "TEXT": "نص",
  "Lng": "خط الطول",
  "Lat": "خط العرض",
  "ALARMSTATUS": "حالة التنبيه",
  "REASON": "السبب",
  "SPEED": "سرعة",
  "STUDENTNAME": "أسم الطالب",
  "CLASS": "الصف ",
  "CAPACITY": "سعة",
  "EXPIRATIONDATE": "تاريخ إنتهاء الصلاحية",
  "BYNATIONALITY": "حسب الجنسية",
  "ABSENCE": "غياب",
  "ADDRESS": "عنوان",
  "ASSIGNEDBUS": "الحافلة المعينة",
  "OPEN": "فتح",
  "REPORTED": "المبلغ عنها",
  "SICKNESS": "المرض",
  "VACATION": "الاجازة",
  "EMERGENCY": "حالة طوارق",
  "PERSONAL": "اسباب شخصية",
  "CHILDBEHAVIOUR": "سلوك الطفل",
  "MEDICAL": " طبي",
  "DRIVERISSUE": "مشكلة السائق",
  "BUSPROBLEM": "مشكلة الحافلة",
  "ACCIDENT": "حادث",
  "TRAFFIC": "حركة المرور",
  "CALLPOLICE": "اتصل بالشرطة",
  "CALLSCHOOL": "اتصل بالمدرسة",
  "OTHER": "آخر",
  "SMOKEDETECTED": "تم الكشف عن الدخان",
  "PANICBUTTONPRESSED": "تم الضغط على زر الهلع",
  "HIGHSPEEDALARM": "تنبيه السرعة العالية",
  "REPORT": "أبلغ عن",
  "GETREPORT": "الحصول على تقرير",
  "GROUPBY": " صنف حسب",
  "GROUPEDBY": "مصنفة حسب",
  "SELECTALL": "اختر الكل",
  "DESELECTALL": "الغاء الكل",
  "SHOW": "عرض",
  "EXPORT": "تصدير",
  "TRIPS": "الرحلات", 
  "SELECTROUTE": "حدد الطريق",
  "SELECTDIRECTION": "حدد الإتجاه",
  "HOMETOSCHOOL": "من البيت الى المدرسة",
  "SCHOOLTOHOME": "من المدرسة الى البيت",
  "PICKARANGE": " اختيار مجموعة",
  "NODATATOSHOW": "لا توجد بيانات للعرض",
  "MINCAPACITY": "الحد الأدنى",
  "MAXCAPACITY": " الحد الأقصى",
  "MINYEAR": "الحد الأدنى العام",
  "MAXYEAR": "الحد الأقصى العام",
  "PICKADATE": "اختر تاريخا",
  "UNIQUECOUNTBY":" احصاء منفرد حسب",
  "FILTERBYSUPERVISOR": "تصفية حسب المشرفة",
  "SELECTNATIONALITY": "حدد الجنسية",
  "SELECTBUS": "حدد الحافلة",
  "FILTERBYDRIVER": "تصفية حسب السائق",
  "SELECTVIOLATION": "حدد الإنتهاك",
  "FILTERBYINCIDENT": "تصفية حسب الحوادث",
  "SELECTONE": "اختر واحد",
  "SELECTMULTIPLE": "اختيار متعدد",
  "SELECTDRIVER": "اختيار السائق",
  "SELECTSUPERVISOR": "اختيار المشرفة",
  "SELECTTYPE": "حدد النوع",
  "SELECTSTATUS": "حدد الحالة",
  "STUDENTS": "الطلاب",
  "SELECTREASON": "حدد السبب",
  "SEARCHADDRESS": "ابحث عن العنوان",
  "SELECTGRADE": "حدد الصف",
  "FILTERBYSTUDENT": "تصفية حسب الطالب",
  "KM": "كم",
  "LOADING": "جار التحميل..."
}
}
</i18n>
<template>
    <el-card  class="card-border" ref="card" id="report" :body-style="{ padding: 0 }" :style="{ height: cardHeight + 'px' }">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;" class="title">{{$t('REPORT')}}</span>       
                <el-dropdown :hide-on-click="hideOnClick" @command="pushDataColumns">
                    <el-button class="first-radius" type="primary">
                        {{$t('GETREPORT')}}<i class="el-icon-caret-bottom el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item><div><el-switch
                                        :width="100"
                                        v-model="groupBy[filterKey]"
                                        :on-text="$t('GROUPEDBY')"
                                        :off-text="$t('GROUPBY')">
                                </el-switch></div>
                        </el-dropdown-item>
                        <el-dropdown-item divided><el-button style="width: 100%;" type="primary" @click="selectAll">{{SelectAll[filterKey] ? $t('SELECTALL') : $t('DESELECTALL')}}</el-button></el-dropdown-item>
                        <el-dropdown-item divided></el-dropdown-item>
                        <el-dropdown-item :key="key" v-for="(item, key) in (!groupBy[filterKey] ? makeList(dataColumns[filterKey],true) : makeList(countDataColumns[filterKey],true,true))" :command="key">{{item}}<span v-if="DataColumn[filterKey].indexOf(key)>=0" class="fa fa-check pull-right"></span></el-dropdown-item>
                        <el-dropdown-item divided><el-button style="width: 100%;" type="primary" :disabled="onClickStatus()" @click="search">{{$t('SHOW')}}</el-button></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button style="border-left-color: rgb(175, 185, 195);" class="second-radius" type="primary" :disabled="filteredData[filterKey].length==0 && filteredCountData[filterKey].length == 0" @click="exportToCSV"><i class="fa fa-download"></i> {{$t('EXPORT')}}</el-button>         
        </div>
        <el-tabs type="border-card" v-model="filterKey" @tab-click="changeFilterKey">
            <el-tab-pane :label="$t('TRIPS')" name="Trip">
                <div :key="index" v-for="(item, index) in DataColumn[filterKey]"></div>
                <el-row class="filters">
                    <el-col :span="24">
                        <el-form ref="form" :model="filters[filterKey]">
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-form-item>
                                        <el-select v-model="filters[filterKey].TourID" :placeholder="$t('SELECTROUTE')" @change="pushFilterBy('TourID', 'Route', 1, false, $event)" filterable :clearable="filters[filterKey].TourID ? true : false">
                                            <el-option
                                            :key="index" 
                                            v-for="(route, index) in routes"
                                            :label="route.TourName"
                                            :value="route.TourID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item>
                                        <el-select v-model="filters[filterKey].Direction" :placeholder="$t('SELECTDIRECTION')" @change="pushFilterBy('Direction', 'Direction', 1, false, $event)" :clearable="filters[filterKey].Direction ? true : false">
                                            <el-option value="1" :label="$t('HOMETOSCHOOL')"></el-option>
                                            <el-option value="2" :label="$t('SCHOOLTOHOME')"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" v-if="filterKey === 'Trip'">
                                    <el-form-item>
                                        <el-date-picker
                                                v-model="filters[filterKey].dateRange"
                                                @change="pushFilterBy('dateRange', 'DateRange', 2, false, $event)"
                                                :picker-options="pickerOption"
                                                type="daterange"
                                                :placeholder="$t('PICKARANGE')">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-col>
                </el-row>
                <div v-if="filterKey === 'Trip'" :style="{opacity:opacity[filterKey], height: loadHeight + 'px'}" id="load-panel" v-loading="loading" :element-loading-text="$t('LOADING')">
                    <el-table
                            v-show="!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
                            :data="filteredData[filterKey][currentPage[filterKey] - 1]"
                            :height="tableHeight"
                            highlight-current-row
                            :empty-text="$t('NODATATOSHOW')"
                            stripe
                            style="width:100%"
                    >
                        <el-table-column
                        :key="key" 
                        v-for="(item, key)  in makeList(dataColumns[filterKey],true)"
                        v-if="DataColumn[filterKey].indexOf(key)>= 0"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                    </el-table>
                    <el-table
                            v-show="groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
                            :data="filteredCountData[filterKey][currentPage[filterKey] - 1]"
                            highlight-current-row
                            :empty-text="$t('NODATATOSHOW')"
                            :height="tableHeight"
                            stripe
                            style="width: 100%">
                        <el-table-column
                        :key="key" 
                        v-for="(item, key) in makeList(countDataColumns[filterKey],true,true)"
                        v-if="!groupBy[filterKey] && (CountDataColumn[filterKey].indexOf(key)>= 0 || key == 'Count')"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                        <el-table-column
                        :key="key" 
                        v-for="(item, key) in makeList(countDataColumns[filterKey],true,true)"
                        v-if="groupBy[filterKey] && DataColumn[filterKey].indexOf(key)>= 0"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                    </el-table>
                    <div class="footer" v-show="checkAllConditions()">
                        <div style="float:left" v-show="filteredData[filterKey].length!=0" >
                            <el-select class="autoWidth" ref="countsBy" size="small" v-model="CountDataColumn[filterKey]" :disabled="!(!groupBy[filterKey] && filteredData[filterKey].length!=0)" @change="uniqueColumnsCount" :placeholder="$t('UNIQUECOUNTBY')" multiple>
                                <el-option
                                :key="key"
                                v-for="(item, key) in makeList(countDataColumns[filterKey],true,true)"
                                v-if="DataColumn[filterKey].indexOf(key)>=0"
                                :label="item"
                                :value="key">
                                </el-option>
                            </el-select>
                        </div>
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage[filterKey]"
                                :page-sizes="[20, 30, 50, 70]"
                                :page-size="limit[filterKey]"
                                layout="total, sizes, prev, pager, next"
                                :total="total[filterKey]"
                                align="right">
                        </el-pagination>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$tc('BUS', 1)" name="Bus" @tab-click="changeFilterKey">
                <div :key="index" v-for="(item, index) in DataColumn[filterKey]"></div>
                <el-row class="filters" :gutter="20">
                    <el-col :span="24">
                        <el-form ref="form" id="busFilters" :model="filters[filterKey]">
                            <el-row :gutter="20">
                                <!-- <el-col :span="4">
                                    <el-form-item>
                                        <el-select 
                                        v-model="filters[filterKey].emirate" 
                                        clearable 
                                        placeholder="Select Emirate"
                                        @input="handleEmirateChange(filterKey)"
                                        @clear="clearEmirate(filterKey)">
                                            <el-option
                                            :key="index" 
                                            v-for="(item, index) in emirates"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" v-show="show.Bus.zone">
                                    <el-form-item>
                                        <el-select
                                        v-model="filters[filterKey].zone" 
                                        clearable 
                                        placeholder="Select Zone"
                                        @input="handleZoneChange(filterKey)"
                                        @clear="clearZone(filterKey)">
                                            <el-option
                                            :key="index" 
                                            v-for="(item, index) in zones"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" v-show="show.Bus.sector">
                                    <el-form-item>
                                        <el-select 
                                        v-model="filters[filterKey].sector" 
                                        clearable placeholder="Select Sector"
                                        @clear="clearSector(filterKey)">
                                            <el-option
                                            :key="index" 
                                            v-for="(item, index) in sectors"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col> -->
                                <!-- <div v-show="show.Bus.others"> -->
                                    <el-col :span="8">
                                        <el-form-item>
                                            <div class="el-input el-input-group el-input-group--prepend">
                                                <div class="el-input-group__prepend buses">
                                                    <el-input type="number" class="need-radius" :placeholder="$t('MINCAPACITY')" v-model="filters[filterKey].minCapacity" @change="pushFilterBy(['minCapacity', 'maxCapacity'], 'Capacity', 1, false, $event)"></el-input>
                                                </div>
                                                <el-input type="number" :placeholder="$t('MAXCAPACITY')" v-model="filters[filterKey].maxCapacity" @change="pushFilterBy(['minCapacity', 'maxCapacity'], 'Capacity', 1, false, $event)"></el-input>
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item>
                                            <div class="el-input el-input-group el-input-group--prepend">
                                                <div class="el-input-group__prepend buses">
                                                <el-select :placeholder="$t('MINYEAR')" v-model="filters[filterKey].minYear" :clearable="filters[filterKey].minYear ? true : false" @change="pushFilterBy(['minYear', 'maxYear'], 'Year', 1, true, $event)">
                                                    <el-option
                                                    :key="index" 
                                                    v-for="(val, index) in range(initialYear,lastYear)"
                                                    :label="val"
                                                    :value="val">
                                                    </el-option>
                                                </el-select>
                                                </div>
                                                <el-select style="width:100%" :placeholder="$t('MAXYEAR')" v-model="filters[filterKey].maxYear" :clearable="filters[filterKey].maxYear ? true : false" :disabled="filters[filterKey].minYear == null" @change="pushFilterBy(['minYear', 'maxYear'], 'Year', 1, false, $event)">
                                                    <el-option
                                                    v-if="val > filters[filterKey].minYear"
                                                    :key="index" 
                                                    v-for="(val, index) in range(initialYear,lastYear)"
                                                    :label="val"
                                                    :value="val">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4" v-if="filterKey === 'Bus'">
                                        <el-form-item>
                                            <el-date-picker
                                                    popper-class="el-date-editor"
                                                    v-model="filters[filterKey].date"
                                                    @change="pushFilterBy('date', 'ExpirationDate', 3, false, $event)"
                                                    type="date"
                                                    :placeholder="$t('PICKADATE')">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                <!-- </div> -->
                            </el-row>
                        </el-form>
                    </el-col>
                </el-row>
                <div v-if="filterKey === 'Bus'" :style="{opacity:opacity[filterKey], height: loadHeight + 'px'}" id="load-panel" v-loading="loading" :element-loading-text="$t('LOADING')">
                    <el-table
                            v-show="!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
                            :data="filteredData[filterKey][currentPage[filterKey] - 1]"
                            :height="tableHeight"
                            highlight-current-row
                            :empty-text="$t('NODATATOSHOW')"
                            stripe
                            style="width:100%"
                    >
                        <el-table-column
                        :key="key" 
                        v-for="(item, key)  in makeList(dataColumns[filterKey],true)"
                        v-if="DataColumn[filterKey].indexOf(key)>= 0"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                    </el-table>
                    <el-table
                            v-show="groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
                            :data="filteredCountData[filterKey][currentPage[filterKey] - 1]"
                            highlight-current-row
                            :empty-text="$t('NODATATOSHOW')"
                            :height="tableHeight"
                            stripe
                            style="width: 100%">
                        <el-table-column
                        :key="key" 
                        v-for="(item, key)  in makeList(countDataColumns[filterKey],true,true)"
                        v-if="!groupBy[filterKey] && (CountDataColumn[filterKey].indexOf(key)>= 0 || key == 'Count')"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                        <el-table-column
                        :key="key" 
                        v-for="(item, key)  in makeList(countDataColumns[filterKey],true,true)"
                        v-if="groupBy[filterKey] && DataColumn[filterKey].indexOf(key)>= 0"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                    </el-table>
                    <div class="footer" v-show="checkAllConditions()">
                        <div style="float:left" v-show="filteredData[filterKey].length!=0" >
                            <el-select class="autoWidth" ref="countsBy" size="small" v-model="CountDataColumn[filterKey]" :disabled="!(!groupBy[filterKey] && filteredData[filterKey].length!=0)" @change="uniqueColumnsCount" :placeholder="$t('UNIQUECOUNTBY')" multiple>
                                <el-option
                                :key="key"
                                v-for="(item, key) in makeList(countDataColumns[filterKey],true,true)"
                                v-if="DataColumn[filterKey].indexOf(key)>=0"
                                :label="item"
                                :value="key">
                                </el-option>
                            </el-select>
                        </div>
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage[filterKey]"
                                :page-sizes="[20, 30, 50, 70]"
                                :page-size="limit[filterKey]"
                                layout="total, sizes, prev, pager, next"
                                :total="total[filterKey]"
                                align="right">
                        </el-pagination>
                    </div>
                </div>
            </el-tab-pane >
            <el-tab-pane :label="$tc('SUPERVISOR', 1)" name="Supervisor">
                <div :key="index" v-for="(item, index) in DataColumn[filterKey]"></div>
                <el-row class="filters" :gutter="20">
                    <el-col :span="8">
                        <el-select v-model="filterBy[filterKey][0]" @change="resetFiltersValue" :placeholder="$t('FILTERBYSUPERVISOR')" :clearable="filterBy[filterKey][0] ? true : false">
                            <el-option
                            :key="key"
                            v-for="(item, key) in makeList(mainTypes[filterKey])"
                            :label="item"
                            :value="key">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="14">
                        <el-form ref="form" id="supervisorFilters" :model="filters[filterKey]">
                            <el-row :gutter="20">
                                <el-col :span="12" v-show="checkIndex('Nationality')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Nationality',true)" ></a>
                                            <el-select :placeholder="$t('SELECTNATIONALITY')" v-model="filters[filterKey].Nationality" filterable :clearable="filters[filterKey].Nationality ? true: false">
                                                <el-option
                                                :key="key"
                                                v-for="(item, key) in $countries"
                                                :label="item"
                                                :value="key">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" v-show="checkIndex('Route')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Route',true)" ></a>
                                            <el-select :placeholder="$t('SELECTROUTE')" v-model="filters[filterKey].TourID" filterable :clearable="filters[filterKey].TourID ? true : false">
                                                <el-option
                                                :key="index" 
                                                v-for="(route, index) in routes"
                                                :label="route.TourName"
                                                :value="route.TourID">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" v-show="checkIndex('Bus')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Bus',true)" ></a>
                                            <el-select :placeholder="$t('SELECTBUS')" v-model="filters[filterKey].BusID" filterable :clearable="filters[filterKey].BusID ? true : false">
                                                <el-option
                                                :key="index" 
                                                v-for="(bus, index) in buses"
                                                :label="bus.Label"
                                                :value="bus.BusID">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" v-show="dateRangeAccess()">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('dateRange',true)" ></a>
                                            <el-date-picker
                                                    v-model="filters[filterKey].dateRange"
                                                    @onClick="resetFiltersValue()"
                                                    :picker-options="pickerOption"
                                                    type="daterange"
                                                    :placeholder="$t('PICKARANGE')">
                                            </el-date-picker>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-col>
                </el-row>
                <div v-if="filterKey === 'Supervisor'" :style="{opacity:opacity[filterKey], height: loadHeight + 'px'}" id="load-panel" v-loading="loading" :element-loading-text="$t('LOADING')">
                    <el-table
                    v-show="!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
                    :data="filteredData[filterKey][currentPage[filterKey] - 1]"
                    :height="tableHeight"
                    highlight-current-row
                    :empty-text="$t('NODATATOSHOW')"
                    stripe
                    style="width:100%"
                    >
                        <el-table-column
                        :key="key" 
                        v-for="(item, key)  in makeList(dataColumns[filterKey],true)"
                        v-if="DataColumn[filterKey].indexOf(key)>= 0"
                        :label="item"
                        align="left"
                        >
                        <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                    </el-table>
                    <el-table
                            v-show="groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
                            :data="filteredCountData[filterKey][currentPage[filterKey] - 1]"
                            highlight-current-row
                            :empty-text="$t('NODATATOSHOW')"
                            :height="tableHeight"
                            stripe
                            style="width: 100%">
                        <el-table-column
                        :key="key" 
                        v-for="(item, key) in makeList(countDataColumns[filterKey],true,true)"
                        v-if="!groupBy[filterKey] && (CountDataColumn[filterKey].indexOf(key)>= 0 || key == 'Count')"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                        <el-table-column
                        :key="key" 
                        v-for="(item, key) 
                        in makeList(countDataColumns[filterKey],true,true)"
                        v-if="groupBy[filterKey] && DataColumn[filterKey].indexOf(key)>= 0"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                    </el-table>
                    <div class="footer" v-show="checkAllConditions()">
                        <div style="float:left" v-show="filteredData[filterKey].length!=0" >
                            <el-select class="autoWidth" ref="countsBy" size="small" v-model="CountDataColumn[filterKey]" :disabled="!(!groupBy[filterKey] && filteredData[filterKey].length!=0)" @change="uniqueColumnsCount" :placeholder="$t('UNIQUECOUNTBY')" multiple>
                                <el-option
                                :key="key"
                                v-for="(item, key) in makeList(countDataColumns[filterKey],true,true)"
                                v-if="DataColumn[filterKey].indexOf(key)>=0"
                                :label="item"
                                :value="key">
                                </el-option>
                            </el-select>
                        </div>
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage[filterKey]"
                                :page-sizes="[20, 30, 50, 70]"
                                :page-size="limit[filterKey]"
                                layout="total, sizes, prev, pager, next"
                                :total="total[filterKey]"
                                >
                        </el-pagination>
                    </div>
                </div>
            </el-tab-pane >
            <el-tab-pane :label="$tc('DRIVER', 1)" name="Driver">
                <div :key="index" v-for="(item, index) in DataColumn[filterKey]"></div>
                <el-row class="filters" :gutter="20">
                    <el-col :span="8">
                        <el-select v-model="filterBy[filterKey][0]" @change="resetFiltersValue" :placeholder="$t('FILTERBYDRIVER')" :clearable="filterBy[filterKey][0] ? true : false">
                            <el-option
                            :key="key"
                            v-for="(item, key) in makeList(mainTypes[filterKey])"
                            :label="item"
                            :value="key">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="14">
                        <el-form ref="form" id="driverFilters" :model="filters[filterKey]">
                            <el-row :gutter="20">
                                <el-col :span="12" v-show="checkIndex('Nationality')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Nationality',true)" ></a>
                                            <el-select :placeholder="$t('SELECTNATIONALITY')" v-model="filters[filterKey].Nationality" filterable :clearable="filters[filterKey].Nationality ? true : false">
                                                <el-option
                                                :key="key"
                                                v-for="(item, key) in $countries"
                                                :label="item"
                                                :value="key">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" v-show="checkIndex('Route')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Route',true)" ></a>
                                            <el-select :placeholder="$t('SELECTROUTE')" v-model="filters[filterKey].TourID" filterable :clearable="filters[filterKey].TourID ? true : false">
                                                <el-option
                                                :key="index" 
                                                v-for="(route, index) in routes"
                                                :label="route.TourName"
                                                :value="route.TourID">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" v-show="checkIndex('Bus')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Bus',true)" ></a>
                                            <el-select :placeholder="$t('SELECTBUS')" v-model="filters[filterKey].BusID" filterable :clearable="filters[filterKey].BusID ? true : false">
                                                <el-option
                                                :key="index" 
                                                v-for="(bus, index) in buses"
                                                :label="bus.Label"
                                                :value="bus.BusID">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" v-show="checkIndex('Violation')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Violation',true)" ></a>
                                            <el-select :placeholder="$t('SELECTVIOLATION')" v-model="filters[filterKey].ViolationTypeID" :clearable="filters[filterKey].ViolationTypeID ? true : false">
                                                <el-option
                                                :key="key"
                                                v-for="(violation,key) in violations"
                                                :label="violation"
                                                :value="key">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" v-show="dateRangeAccess()">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('dateRange',true)" ></a>
                                            <el-date-picker
                                                    v-model="filters[filterKey].dateRange"
                                                    @onClick="resetFiltersValue()"
                                                    type="daterange"
                                                    :picker-options="pickerOption"
                                                    :placeholder="$t('PICKARANGE')">
                                            </el-date-picker>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-col>
                </el-row>
                <div v-if="filterKey === 'Driver'" :style="{opacity:opacity[filterKey], height: loadHeight + 'px'}" id="load-panel" v-loading="loading" :element-loading-text="$t('LOADING')">
                    <el-table
                            v-show="!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
                            :data="filteredData[filterKey][currentPage[filterKey] - 1]"
                            :height="tableHeight"
                            highlight-current-row
                            :empty-text="$t('NODATATOSHOW')"
                            stripe
                            style="width:100%"
                    >
                        <el-table-column
                                :key="key" 
                                v-for="(item, key)  in makeList(dataColumns[filterKey],true)"
                                v-if="DataColumn[filterKey].indexOf(key)>= 0"
                                :label="item"
                                align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                    </el-table>
                    <el-table
                            v-show="groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
                            :data="filteredCountData[filterKey][currentPage[filterKey] - 1]"
                            highlight-current-row
                            :empty-text="$t('NODATATOSHOW')"
                            :height="tableHeight"
                            stripe
                            style="width: 100%">
                        <el-table-column
                        :key="key" 
                        v-for="(item, key)  in makeList(countDataColumns[filterKey],true,true)"
                        v-if="!groupBy[filterKey] && (CountDataColumn[filterKey].indexOf(key)>= 0 || key == 'Count')"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                        <el-table-column
                        :key="key" 
                        v-for="(item, key)  in makeList(countDataColumns[filterKey],true,true)"
                        v-if="groupBy[filterKey] && DataColumn[filterKey].indexOf(key)>= 0"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                    </el-table>
                    <div class="footer" v-show="checkAllConditions()">
                        <div style="float:left" v-show="filteredData[filterKey].length!=0" >
                            <el-select class="autoWidth" ref="countsBy" size="small" v-model="CountDataColumn[filterKey]" :disabled="!(!groupBy[filterKey] && filteredData[filterKey].length!=0)" @change="uniqueColumnsCount" :placeholder="$t('UNIQUECOUNTBY')" multiple>
                                <el-option
                                :key="key"
                                v-for="(item, key) in makeList(countDataColumns[filterKey],true,true)"
                                v-if="DataColumn[filterKey].indexOf(key)>=0"
                                :label="item"
                                :value="key">
                                </el-option>
                            </el-select>
                        </div>
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage[filterKey]"
                                :page-sizes="[20, 30, 50, 70]"
                                :page-size="limit[filterKey]"
                                layout="total, sizes, prev, pager, next"
                                :total="total[filterKey]"
                                >
                        </el-pagination>
                    </div>
                </div>
            </el-tab-pane >
            <el-tab-pane :label="$t('INCIDENT')" name="Incident">
                <div :key="index" v-for="(item, index) in DataColumn[filterKey]"></div>
                <el-row class="filters" :gutter="20">
                    <el-col :span="8">
                        <el-select v-model="conditionalFilterBy" @change="resetFiltersValue" @handleOptionClick="handleGroupedOption" @remove-tag="removeTag" :placeholder="$t('FILTERBYINCIDENT')" multiple>
                            <el-option-group :label="$t('SELECTONE')">
                                <el-option
                                :key="index"
                                v-for="(item, key, index) in makeList(mainTypes[filterKey])"
                                v-if="index < 3"
                                :label="item"
                                :value="key">
                                </el-option>
                            </el-option-group>
                            <el-option-group :label="$t('SELECTMULTIPLE')">
                                <el-option
                                :key="index"
                                v-for="(item, key, index) in makeList(mainTypes[filterKey])"
                                v-if="index >= 3"
                                :label="item"
                                :value="key">
                                </el-option>
                            </el-option-group>
                        </el-select>
                    </el-col>
                    <el-col :span="16">
                        <el-form ref="form" id="incidentFilters" :model="filters[filterKey]">
                            <el-row :gutter="20">
                                <el-col :span="getDynamicSpan()" v-show="checkIndex('Driver')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Driver',true)" ></a>
                                            <el-select :placeholder="$t('SELECTDRIVER')" v-model="filters[filterKey].BusDriverID" filterable :clearable="filters[filterKey].BusDriverID ? true : false">
                                                <el-option
                                                :key="index" 
                                                v-for="(driver, index) in drivers"
                                                :label="_FullName({NameEN: driver.FullName_EN, NameAR: driver.FullName_AR})"
                                                :value="driver.BusDriverID">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="getDynamicSpan()" v-show="checkIndex('Supervisor')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Supervisor',true)" ></a>
                                            <el-select :placeholder="$t('SELECTSUPERVISOR')" v-model="filters[filterKey].BusMonitorID" filterable :clearable="filters[filterKey].BusMonitorID ? true : false">
                                                <el-option
                                                :key="index" 
                                                v-for="(monitor, index) in monitors"
                                                :label="_FullName({NameEN: monitor.FullName_EN, NameAR: monitor.FullName_AR})"
                                                :value="monitor.BusMonitorID">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="getDynamicSpan()" v-show="checkIndex('Bus')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Bus',true)" ></a>
                                            <el-select :placeholder="$t('SELECTBUS')" v-model="filters[filterKey].BusID" filterable :clearable="filters[filterKey].BusID ? true : false">
                                                <el-option
                                                :key="index" 
                                                v-for="(bus, index) in buses"
                                                :label="bus.Label"
                                                :value="bus.BusID">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="getDynamicSpan()" v-show="checkIndex('Type')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Type',true)" ></a>
                                            <el-select :placeholder="$t('SELECTTYPE')" v-model="filters[filterKey].IncidentTypeID" :clearable = "filters[filterKey].IncidentTypeID ? true : false">
                                                <el-option
                                                :key="key"
                                                v-for="(incident,key) in incidents"
                                                :label="incident"
                                                :value="key">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="getDynamicSpan()" v-show="checkIndex('Status')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Status',true)" ></a>
                                            <el-select :placeholder="$t('SELECTSTATUS')" v-model="filters[filterKey].Status" :clearable = "filters[filterKey].Status ? true : false">
                                                <el-option
                                                :key="index" 
                                                v-for="(status, index) in Statuses"
                                                :label="status"
                                                :value="status">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="getDynamicSpan()" v-show="dateRangeAccess()">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('dateRange',true)" ></a>
                                            <el-date-picker
                                                    v-model="filters[filterKey].dateRange"
                                                    @onClick="resetFiltersValue()"
                                                    type="daterange"
                                                    :picker-options="pickerOption"
                                                    :placeholder="$t('PICKARANGE')">
                                            </el-date-picker>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-col>
                </el-row>
                <div v-if="filterKey === 'Incident'" :style="{opacity:opacity[filterKey], height: loadHeight + 'px'}" id="load-panel" v-loading="loading" :element-loading-text="$t('LOADING')">
                    <el-table
                            v-show="!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
                            :data="filteredData[filterKey][currentPage[filterKey] - 1]"
                            :height="tableHeight"
                            highlight-current-row
                            :empty-text="$t('NODATATOSHOW')"
                            stripe
                            style="width:100%"
                    >
                        <el-table-column
                        :key="key" 
                        v-for="(item, key)  in makeList(dataColumns[filterKey],true)"
                        v-if="DataColumn[filterKey].indexOf(key)>= 0"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                    </el-table>
                    <el-table
                            v-show="groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
                            :data="filteredCountData[filterKey][currentPage[filterKey] - 1]"
                            highlight-current-row
                            :empty-text="$t('NODATATOSHOW')"
                            :height="tableHeight"
                            stripe
                            style="width: 100%">
                        <el-table-column
                        :key="key" 
                        v-for="(item, key) in makeList(countDataColumns[filterKey],true,true)"
                        v-if="!groupBy[filterKey] && (CountDataColumn[filterKey].indexOf(key)>= 0 || key == 'Count')"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                        <el-table-column
                        :key="key" 
                        v-for="(item, key)  in makeList(countDataColumns[filterKey],true,true)"
                        v-if="groupBy[filterKey] && DataColumn[filterKey].indexOf(key)>= 0"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                    </el-table>
                    <div class="footer" v-show="checkAllConditions()">
                        <div style="float:left" v-show="filteredData[filterKey].length!=0" >
                            <el-select class="autoWidth" ref="countsBy" size="small" v-model="CountDataColumn[filterKey]" :disabled="!(!groupBy[filterKey] && filteredData[filterKey].length!=0)" @change="uniqueColumnsCount" :placeholder="$t('UNIQUECOUNTBY')" multiple>
                                <el-option
                                :key="key"
                                v-for="(item, key) in makeList(countDataColumns[filterKey],true,true)"
                                v-if="DataColumn[filterKey].indexOf(key)>=0"
                                :label="item"
                                :value="key">
                                </el-option>
                            </el-select>
                        </div>
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage[filterKey]"
                                :page-sizes="[20, 30, 50, 70]"
                                :page-size="limit[filterKey]"
                                layout="total, sizes, prev, pager, next"
                                :total="total[filterKey]"
                               >
                        </el-pagination>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('STUDENTS')" name="Student">
                <div :key="index" v-for="(item, index) in DataColumn[filterKey]"></div>
                <el-row class="filters" :gutter="20">
                    <!-- <el-col :span="4">         
                        <el-select 
                        v-model="filters[filterKey].emirate" 
                        clearable 
                        placeholder="Select Emirate"
                        @input="handleEmirateChange(filterKey)"
                        @clear="clearEmirate(filterKey)">
                            <el-option
                            :key="index" 
                            v-for="(item, index) in emirates"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="4" v-show="show.Student.zone">
                            <el-select 
                            v-model="filters[filterKey].zone" 
                            clearable 
                            placeholder="Select Zone"
                            @input="handleZoneChange(filterKey)"
                            @clear="clearZone(filterKey)">
                                <el-option
                                :key="index" 
                                v-for="(item, index) in zones"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                    </el-col>
                    <el-col :span="4" v-show="show.Student.sector">
                            <el-select 
                            v-model="filters[filterKey].sector" 
                            clearable placeholder="Select Sector"
                            @clear="clearSector(filterKey)">
                                <el-option
                                :key="index" 
                                v-for="(item, index) in sectors"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                    </el-col> -->
                    <!-- <div v-show="show.Student.others"> -->
                    <el-col :span="8">
                        <el-select v-model="conditionalFilterBy" @change="resetFiltersValue" @handleOptionClick="handleGroupedOption" @remove-tag="removeTag" :placeholder="$t('FILTERBYSTUDENT')" multiple>
                            <el-option-group :label="$t('SELECTONE')">
                                <el-option
                                :key="index"
                                v-for="(item, key, index) in makeList(mainTypes[filterKey])"
                                v-if="index < 3"
                                :label="item"
                                :value="key">
                                </el-option>
                            </el-option-group>
                            <el-option-group :label="$t('SELECTMULTIPLE')">
                                <el-option
                                :key="index"
                                v-for="(item, key, index) in makeList(mainTypes[filterKey])"
                                v-if="index >= 3"
                                :label="item"
                                :value="key">
                                </el-option>
                            </el-option-group>
                        </el-select>
                    </el-col>
                    <el-col :span="16">
                        <el-form ref="form" id="studentFilters" :model="filters[filterKey]">
                            <el-row :gutter="20">
                                <el-col :span="16" v-show="checkIndex('Absence')">
                                    <el-row :gutter="20">
                                        <el-col :span="10">
                                            <el-form-item>
                                                <div class="el-input el-input-group el-input-group--prepend">
                                                    <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Absence',true)" ></a>
                                                    <el-select :placeholder="$t('SELECTREASON')" v-model="filters[filterKey].Reason" :clearable="filters[filterKey].Reason ? true : false">
                                                        <el-option
                                                        :key="index" 
                                                        v-for="(reason, index) in reasons"
                                                        :label="reason"
                                                        :value="reason">
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="14" v-show="dateRangeAccess()">
                                            <el-form-item>
                                                <div class="el-input el-input-group el-input-group--prepend">
                                                    <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('dateRange',true)" ></a>
                                                    <el-date-picker
                                                            v-model="filters[filterKey].dateRange"
                                                            type="daterange"
                                                            :picker-options="pickerOption"
                                                            :placeholder="$t('PICKARANGE')">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="16" v-show="checkIndex('Address')">
                                    <el-row :gutter="20">
                                        <el-col :span="16">
                                            <el-form-item>
                                                <div class="el-input el-input-group el-input-group--prepend">
                                                    <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Address',true)" ></a>
                                                    <input type="text" :placeholder="$t('SEARCHADDRESS')"  id="location" class="el-input__inner"  autocomplete="off" >
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item>
                                                <el-input type="number" placeholder="Range" :step="0.5" v-model="filters[filterKey].radius">
                                                    <template slot="append">{{$t('KM')}}</template>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="12" v-show="checkIndex('Bus')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Bus',true)" ></a>
                                            <el-select :placeholder="$t('SELECTBUS')" v-model="filters[filterKey].BusID" filterable :clearable = "filters[filterKey].BusID ? true : false">
                                                <el-option
                                                :key="index" 
                                                v-for="(bus, index) in buses"
                                                :label="bus.Label"
                                                :value="bus.BusID">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" v-show="checkIndex('Grade')">
                                    <el-form-item>
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <a class="el-input-group__prepend el-button el-icon-close" @click="removeIndex('Grade',true)" ></a>
                                            <el-select :placeholder="$t('SELECTGRADE')" v-model="filters[filterKey].Grade" filterable :clearable="filters[filterKey].Grade ? true : false">
                                                <el-option
                                                :key="index" 
                                                v-for="(grade, index) in grades"
                                                :label="grade.Name"
                                                :value="grade.Name">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-col>
                    <!-- </div> -->
                </el-row>
                <div v-if="filterKey === 'Student'" :style="{opacity:opacity[filterKey], height: loadHeight + 'px'}" id="load-panel" v-loading="loading" :element-loading-text="$t('LOADING')">
                    <el-table
                            v-show="!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
                            :data="filteredData[filterKey][currentPage[filterKey] - 1]"
                            :height="tableHeight"
                            highlight-current-row
                            :empty-text="$t('NODATATOSHOW')"
                            stripe
                            style="width:100%"
                    >
                        <el-table-column
                        :key="key" 
                        v-for="(item, key)  in makeList(dataColumns[filterKey],true)"
                        v-if="DataColumn[filterKey].indexOf(key)>= 0"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                    </el-table>
                    <el-table
                            v-show="groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
                            :data="filteredCountData[filterKey][currentPage[filterKey] - 1]"
                            highlight-current-row
                            :empty-text="$t('NODATATOSHOW')"
                            :height="tableHeight"
                            stripe
                            style="width: 100%">
                        <el-table-column
                        :key="key" 
                        v-for="(item, key) in makeList(countDataColumns[filterKey],true,true)"
                        v-if="!groupBy[filterKey] && (CountDataColumn[filterKey].indexOf(key)>= 0 || key == 'Count')"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                        <el-table-column
                        :key="key" 
                        v-for="(item, key)  in makeList(countDataColumns[filterKey],true,true)"
                        v-if="groupBy[filterKey] && DataColumn[filterKey].indexOf(key)>= 0"
                        :label="item"
                        align="left"
                        >
                            <template slot-scope="scope">{{scope.row[key]}}</template>
                        </el-table-column>
                    </el-table>
                    <div class="footer" v-show="checkAllConditions()">
                        <div style="float:left" v-show="filteredData[filterKey].length!=0" >
                            <el-select class="autoWidth" ref="countsBy" size="small" v-model="CountDataColumn[filterKey]" :disabled="!(!groupBy[filterKey] && filteredData[filterKey].length!=0)" @change="uniqueColumnsCount" :placeholder="$t('UNIQUECOUNTBY')" multiple>
                                <el-option
                                :key="key"
                                v-for="(item, key) in makeList(countDataColumns[filterKey],true,true)"
                                v-if="DataColumn[filterKey].indexOf(key)>=0"
                                :label="item"
                                :value="key">
                                </el-option>
                            </el-select>
                        </div>
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage[filterKey]"
                                :page-sizes="[20, 30, 50, 70]"
                                :page-size="limit[filterKey]"
                                layout="total, sizes, prev, pager, next"
                                :total="total[filterKey]"
                                >
                        </el-pagination>
                    </div>
                </div>
            </el-tab-pane >
        </el-tabs>
    </el-card>
</template>
<script>
  import Vue from 'vue'
  import axios from 'axios'
  import qs from 'qs'
  import _ from 'lodash'
  export default {
    data () {
      return {
        currentPage: {'Trip': 1, 'Bus': 1, 'Supervisor': 1, 'Driver': 1, 'Incident': 1, 'Student': 1},
        total: {'Trip': 0, 'Bus': 0, 'Supervisor': 0, 'Driver': 0, 'Incident': 0, 'Student': 0},
        limit: {'Trip': 20, 'Bus': 20, 'Supervisor': 20, 'Driver': 20, 'Incident': 20, 'Student': 20},
        visitedPage: {'Trip': [1], 'Bus': [1], 'Supervisor': [1], 'Driver': [1], 'Incident': [1], 'Student': [1]},
        currentRow: null,
        SelectAll: {'Trip': true, 'Bus': true, 'Supervisor': true, 'Driver': true, 'Incident': true, 'Student': true},
        filterKey: 'Trip',
        filterBy: {'Trip': [], 'Bus': [], 'Supervisor': [], 'Driver': [], 'Incident': [], 'Student': []},
        filteredData: {'Trip': [], 'Bus': [], 'Supervisor': [], 'Driver': [], 'Incident': [], 'Student': []},
        filteredCountData: {'Trip': [], 'Bus': [], 'Supervisor': [], 'Driver': [], 'Incident': [], 'Student': []},
        extra: {'Trip': false, 'Bus': false, 'Supervisor': false, 'Driver': false, 'Incident': false, 'Student': false},
        groupBy: {'Trip': false, 'Bus': false, 'Supervisor': false, 'Driver': false, 'Incident': false, 'Student': false},
        filters: {
          'Trip': {'TourID': null, 'Direction': null, 'dateRange': [null, null]},
          'Bus': {'minCapacity': null, 'maxCapacity': null, 'minYear': null, 'maxYear': null, 'date': null, 'emirate': null, 'zone': null, 'sector': null},
          'Supervisor': {'Nationality': null, 'TourID': null, 'BusID': null, 'dateRange': [null, null], 'ViolationTypeID': null},
          'Driver': {'Nationality': null, 'TourID': null, 'BusID': null, 'dateRange': [null, null], 'ViolationTypeID': null},
          'Incident': {'BusDriverID': null, 'BusMonitorID': null, 'BusID': null, 'IncidentTypeID': null, 'Status': null, 'dateRange': [null, null], 'ViolationTypeID': null},
          'Student': {'Reason': null, 'radius': null, 'BusID': null, 'Grade': null, 'Status': null, 'dateRange': [null, null], 'ViolationTypeID': null, 'longitude': 0, 'latitude': 0, 'emirate': null, 'zone': null, 'sector': null}
        },
        title: {'Trip': '', 'Bus': '', 'Supervisor': '', 'Driver': '', 'Incident': '', 'Student': ''},
        routes: [],
        buses: [],
        drivers: [],
        monitors: [],
        grades: [],
        classes: [],
        country: 'AE',
        Location: null,
        DataColumn: {'Trip': [], 'Bus': [], 'Supervisor': [], 'Driver': [], 'Incident': [], 'Student': []},
        CountDataColumn: {'Trip': [], 'Bus': [], 'Supervisor': [], 'Driver': [], 'Incident': [], 'Student': []},
        savedQuery: {'Trip': '', 'Bus': '', 'Supervisor': '', 'Driver': '', 'Incident': '', 'Student': ''},
        opacity: {'Trip': 0, 'Bus': 0, 'Supervisor': 0, 'Driver': 0, 'Incident': 0, 'Student': 0},
        multipleLimit: 0,
        loading: false,
        runTimeMethod: {
          1: function (param) { return _.isEmpty(param) },
          2: function (param) { return _.isNull(param[0]) },
          3: function (param) { return !_.isDate(param) }
        },
        tableHeight: 0,
        cardHeight: 0,
        loadHeight: 0,
        initialYear: new Date().getFullYear() - 20,
        lastYear: new Date().getFullYear() + 1,
        hideOnClick: false,
        pickerOption: {
          disabledDate (time) {
            return time.getTime() >= Date.now()
          }
        },
        multiSelectComponents: [],
        singleSelectComponent: null
        // emirates: [
        //   {
        //     value: 'Abu Dhabi',
        //     label: 'Abu Dhabi'
        //   },
        //   {
        //     value: 'Dubai',
        //     label: 'Dubai'
        //   },
        //   {
        //     value: 'Sharjah',
        //     label: 'Sharjah'
        //   },
        //   {
        //     value: 'Ajman',
        //     label: 'Ajman'
        //   },
        //   {
        //     value: 'Fujairah',
        //     label: 'Fujairah'
        //   },
        //   {
        //     value: 'Ras Al Khaimah',
        //     label: 'Ras Al Khaimah'
        //   },
        //   {
        //     value: 'Umm Al Quwain',
        //     label: 'Umm Al Quwain'
        //   }
        // ],
        // zones: [
        //   {
        //     value: 'zone1',
        //     label: 'zone1'
        //   },
        //   {
        //     value: 'zone2',
        //     label: 'zone2'
        //   },
        //   {
        //     value: 'zone3',
        //     label: 'zone3'
        //   }
        // ],
        // sectors: [
        //   {
        //     value: 'sector1',
        //     label: 'sector1'
        //   },
        //   {
        //     value: 'sector2',
        //     label: 'sector2'
        //   },
        //   {
        //     value: 'sector3',
        //     label: 'sector3'
        //   }
        // ],
        // show: {
        //   Bus: {
        //     zone: false,
        //     sector: false,
        //     others: true
        //   },
        //   Student: {
        //     zone: false,
        //     sector: false,
        //     others: true
        //   }
        // }
      }
    },
    mounted () {
      this.switchLanguage()
      this.$nextTick(function () {
        this.cardHeight = window.innerHeight - this.$el.offsetHeight - 53
        this.loadHeight = window.innerHeight - document.getElementById('load-panel').offsetTop
        this.tableHeight = this.loadHeight - 152
        let el = this.$refs.countsBy.$el
        el.style.width = Math.max(220, el.firstChild.firstChild.offsetWidth + 34) + 'px'
        let self = this
        this.$google.then(function (Maps) {
          self.maps = Maps
          let country = JSON.parse(localStorage.getItem('locale')).country
          let autocomplete = new Maps.places.Autocomplete((document.getElementById('location')), {componentRestrictions: {country: country}})
          Maps.event.addListener(autocomplete, 'place_changed', function () {
            self.setPlace(autocomplete.getPlace())
          })
        })
        axios.all([this.$http.get('/route?ref=report'), this.$http.get('/bus?ref=report'), this.$http.get('/driver?ref=report'), this.$http.get('/supervisor?ref=report'), this.$http.get('/configuration/grade')])
          .then(axios.spread(function (routes, buses, drivers, monitors, levels) {
            self.routes = routes.data
            self.buses = buses.data
            self.drivers = drivers.data
            self.monitors = monitors.data
            self.grades = levels.data
          })).catch(function (response) {
            console.log(response)
          })
      })
    },
    computed: {
      conditionalFilterBy: {
        get: function () {
          return this.filterBy[this.filterKey]
        },
        set: function (val) {
          this.filterBy[this.filterKey] = val
        }
      },
      date: {
        get: function () {
          return this.filters[this.filterKey]['date']
        },
        set: function (val) {
          this.filters[this.filterKey]['date'] = val
        }
      },
      countDataColumns () {
        return {
          Trip: [
            {BusMonitorID: this.$tc('SUPERVISOR', 0)},
            {BusDriverID: this.$tc('DRIVER', 0)},
            {TourName: this.$t('ROUTE')},
            {Direction: this.$t('DIRECTION')},
            {Date: this.$t('DATE')},
            {Count: this.$t('COUNT')}
          ],
          Bus: [
            {Make: this.$t('MAKE')},
            {Year: this.$t('YEAR')},
            {Count: this.$t('COUNT')}
          ],
          Supervisor: [
            {
              Bus: [
                {Make: this.$t('MAKE')},
                {Year: this.$t('YEAR')},
                {Count: this.$t('COUNT')}
              ],
              Nationality: [
                {Gender: this.$t('GENDER')},
                {Nationality: this.$t('NATIONALITY')},
                {Count: this.$t('COUNT')}
              ],
              Route: [
                {TourName: this.$t('ROUTE')},
                {Count: this.$t('COUNT')}
              ],
              Incident: [
                {TourName: this.$t('ROUTE')},
                {Label: this.$t('TYPE')},
                {Status: this.$t('STATUS')},
                {Count: this.$t('COUNT')}
              ]
            },
            {Gender: this.$t('GENDER')},
            {Nationality: this.$t('NATIONALITY')},
            {Count: this.$t('COUNT')}
          ],
          Driver: [
            {
              Bus: [
                {Make: this.$t('MAKE')},
                {Year: this.$t('YEAR')},
                {Count: this.$t('COUNT')}
              ],
              Nationality: [
                {Gender: this.$t('GENDER')},
                {Nationality: this.$t('NATIONALITY')},
                {Count: this.$t('COUNT')}
              ],
              Route: [
                {TourName: this.$t('ROUTE')},
                {Count: this.$t('COUNT')}
              ],
              Violation: [
                {TourName: this.$t('ROUTE')},
                {Label: this.$t('TYPE')},
                {AlarmStatus: this.$t('ALARMSTATUS')},
                {Count: this.$t('COUNT')}
              ],
              Incident: [
                {TourName: this.$t('ROUTE')},
                {Label: this.$t('TYPE')},
                {Status: this.$t('STATUS')},
                {Count: this.$t('COUNT')}
              ]

            },
            {Gender: this.$t('GENDER')},
            {Nationality: this.$t('NATIONALITY')},
            {Count: this.$t('COUNT')}
          ],
          Incident: [
            {TourName: this.$t('ROUTE')},
            {BusDriverID: this.$tc('DRIVER', 0)},
            {Label: this.$t('TYPE')},
            {Status: this.$t('STATUS')},
            {Count: this.$t('COUNT')}
          ],
          Student: [
            {
              Absence: [
                {Reason: this.$t('REASON')},
                {Gender: this.$t('GENDER')},
                {Nationality: this.$t('NATIONALITY')},
                {Count: this.$t(' COUNT')}
              ]
            },
            {Gender: this.$t('GENDER')},
            {Nationality: this.$t('NATIONALITY')},
            {Grade: this.$t('GRADE')},
            {Count: this.$t('COUNT')}
          ]
        }
      },
      dataColumns () {
        return {
          Trip: [
            {TourName: this.$t('ROUTE')},
            {BusMonitorID: this.$tc('SUPERVISOR', 0)},
            {BusDriverID: this.$tc('DRIVER', 0)},
            {Stops: this.$t('STOP')},
            {Students: this.$t('STUDENT')},
            {Direction: this.$t('DIRECTION')},
            {CompletedTime: this.$t('COMPLETEDTIME')},
            {Date: this.$t('DATE')}
          ],
          Bus: [
            {Label: this.$t('BUSNUMBER')},
            {Make: this.$t('MAKE')},
            {Year: this.$t('YEAR')},
            {Plate: this.$t('PLATE')},
            {RegistrationExpiration: this.$t('EXPIRATIONDATE')}
          ],
          Supervisor: [
            {
              Bus: [
                {BusMonitorID: this.$tc('SUPERVISOR', 0)},
                {BusID: this.$t('LABEL')},
                {Make: this.$t('MAKE')},
                {Year: this.$t('YEAR')}
              ],
              Nationality: [
                {BusMonitorID: this.$tc('SUPERVISOR', 0)},
                {Gender: this.$t('GENDER')},
                {Nationality: this.$t('NATIONALITY')},
                {IDExpiration: this.$t('IDEXPIRATION')}
              ],
              Route: [
                {BusMonitorID: this.$tc('SUPERVISOR', 0)},
                {TourName: this.$t('ROUTE')}
              ],
              Incident: [
                {BusMonitorID: this.$tc('SUPERVISOR', 0)},
                {TourName: this.$t('ROUTE')},
                {Text: this.$t('TEXT')},
                {Label: this.$t('TYPE')},
                {Status: this.$t('STATUS')},
                {Lng: this.$t('Lng')},
                {Lat: this.$t('Lat')}
              ]
            },
            {BusMonitorID: this.$tc('SUPERVISOR', 0)},
            {Gender: this.$t('GENDER')},
            {Nationality: this.$t('NATIONALITY')},
            {IDExpiration: this.$t('IDEXPIRATION')}
          ],
          Driver: [
            {
              Bus: [
                {BusDriverID: this.$tc('DRIVER', 0)},
                {BusID: this.$t('LABEL')},
                {Make: this.$t('MAKE')},
                {Year: this.$t('YEAR')}
              ],
              Nationality: [
                {BusDriverID: this.$tc('DRIVER', 0)},
                {Gender: this.$t('GENDER')},
                {Nationality: this.$t('NATIONALITY')},
                {IDExpiration: this.$t('IDEXPIRATION')}
              ],
              Route: [
                {BusDriverID: this.$tc('DRIVER', 0)},
                {TourName: this.$t('ROUTE')}
              ],
              Violation: [
                {BusDriverID: this.$tc('DRIVER', 0)},
                {TourName: this.$t('ROUTE')},
                {Label: this.$t('TYPE')},
                {AlarmStatus: this.$t('ALARMSTATUS')},
                {Speed: this.$t('SPEED')},
                {Date: this.$t('DATE')},
                {Lng: this.$t('Lng')},
                {Lat: this.$t('Lat')}
              ],
              Driver: [
                {BusMonitorID: this.$tc('SUPERVISOR', 0)},
                {TourName: this.$t('ROUTE')},
                {Text: this.$t('TEXT')},
                {Label: this.$t('TYPE')},
                {Status: this.$t('STATUS')},
                {Lng: this.$t('Lng')},
                {Lat: this.$t('Lat')}
              ]
            },
            {BusDriverID: this.$tc('DRIVER', 0)},
            {Gender: this.$t('GENDER')},
            {Nationality: this.$t('NATIONALITY')},
            {IDExpiration: this.$t('IDEXPIRATION')}
          ],
          Incident: [
            {TourName: this.$t('ROUTE')},
            {BusMonitorID: this.$tc('SUPERVISOR', 0)},
            {BusDriverID: this.$tc('DRIVER', 0)},
            {Text: this.$t('TEXT')},
            {Label: this.$t('TYPE')},
            {Status: this.$t('STATUS')},
            {Date: this.$t('DATE')},
            {Lng: this.$t('Lng')},
            {Lat: this.$t('Lat')}
          ],
          Student: [
            {
              Absence: [
                {Date: this.$t('DATE')},
                {StudentID: this.$t('STUDENTNAME')},
                {Reason: this.$t('REASON')},
                {Gender: this.$t('GENDER')},
                {Nationality: this.$t('NATIONALITY')},
                {Grade: this.$t('GRADE')},
                {Class: this.$t('CLASS')}
              ]
            },
            {StudentID: this.$t('STUDENTNAME')},
            {Gender: this.$t('GENDER')},
            {Nationality: this.$t('NATIONALITY')},
            {Grade: this.$t('GRADE')},
            {Class: this.$t('CLASS')}
          ]
        }
      },
      mainTypes () {
        return {
          Trip: [
            {Route: this.$t('ROUTE')},
            {Direction: this.$t('DIRECTION')},
            {DateRange: this.$t('DATERANGE')}
          ],
          Bus: [
            {Capacity: this.$t('CAPACITY')},
            {Year: this.$t('YEAR')},
            {ExpirationDate: this.$t('EXPIRATIONDATE')}
          ],
          Supervisor: [
            {Nationality: this.$t('BYNATIONALITY')},
            {Route: this.$t('ROUTE')},
            {Bus: this.$tc('BUS', 0)},
            {Incident: this.$t('INCIDENT')}
          ],
          Driver: [
            {Nationality: this.$t('BYNATIONALITY')},
            {Route: this.$t('ROUTE')},
            {Bus: this.$tc('BUS', 0)},
            {Violation: this.$t('VIOLATION')},
            {Incident: this.$t('INCIDENT')}
          ],
          Incident: [
            {Driver: this.$tc('DRIVER', 0)},
            {Supervisor: this.$tc('SUPERVISOR', 0)},
            {Bus: this.$tc('BUS', 0)},
            {Type: this.$t('TYPE')},
            {DateRange: this.$t('DATE')},
            {Status: this.$t('STATUS')}
          ],
          Student: [
            {Absence: this.$t('ABSENCE'), radio: true},
            {Address: this.$t('ADDRESS'), radio: true},
            {Bus: this.$t('ASSIGNEDBUS'), radio: true},
            {Grade: this.$t('GRADE')}
          ]
        }
      },
      Statuses () {
        return {Open: this.$t('OPEN'), Reported: this.$t('REPORTED')}
      },
      reasons () {
        return {Sickness: this.$t('SICKNESS'), Vacation: this.$t('VACATION'), Emergency: this.$t('EMERGENCY'), Personal: this.$t('PERSONAL')}
      },
      incidents () {
        return {1: this.$t('CHILDBEHAVIOUR'), 2: this.$t('MEDICAL'), 3: this.$t('DRIVERISSUE'), 4: this.$t('BUSPROBLEM'), 5: this.$t('ACCIDENT'), 6: this.$t('TRAFFIC'), 7: this.$t('CALLPOLICE'), 8: this.$t('CALLSCHOOL'), 9: this.$t('OTHER')}
      },
      violations () {
        return {5: this.$t('SMOKEDETECTED'), 13: this.$t('PANICBUTTONPRESSED'), 15: this.$t('HIGHSPEEDALARM')}
      }
    },
    watch: {
      savedQuery: {
        handler: function (val, oldVal) {
          this.opacity[this.filterKey] = 1
          if (this.savedQuery[this.filterKey] !== localStorage.getItem('savedQuery' + this.filterKey)) this.opacity[this.filterKey] = 0.5
        },
        deep: true
      },
      DataColumn: {
        handler: function (val, oldVal) {
          this.savedQuery[this.filterKey] = JSON.stringify(this.filters[this.filterKey]) + this.dataColumnSerialize()
        },
        deep: true
      },
      filters: {
        handler: function (val, oldVal) {
          this.savedQuery[this.filterKey] = JSON.stringify(this.filters[this.filterKey]) + this.dataColumnSerialize()
        },
        deep: true
      }
    },
    methods: {
      handleCurrentChange (val) {
        this.currentPage[this.filterKey] = val
        if (this.visitedPage[this.filterKey].indexOf(val) >= 0) return
        this.visitedPage[this.filterKey].push(val)
        this.search()
      },
      makeList (lists, extra, count) {
        let data = {}
        if (extra !== undefined) {
          Vue.set(this.extra, this.filterKey, true)
          data = (count !== undefined) ? this.countDataColumns : this.dataColumns
          if (this.filterKey === 'Driver' || this.filterKey === 'Supervisor' || this.filterKey === 'Student') {
            if (this.filterBy[this.filterKey][0] === 'Incident') return this.makeList(data['Incident'])
            if (this.filterBy[this.filterKey].indexOf('Absence') < 0 && this.filterKey === 'Student') return this.makeList(data['Student'])
            if (this.groupBy[this.filterKey] && this.filterBy[this.filterKey].indexOf('Absence') >= 0 && this.filterKey === 'Student') return this.absenceGroupByColumns(this.makeList(data[this.filterKey][0][this.filterBy[this.filterKey][this.filterBy[this.filterKey].indexOf('Absence')]]))
            if (this.filterBy[this.filterKey].indexOf('Absence') >= 0 && this.filterKey === 'Student') return this.makeList(data[this.filterKey][0][this.filterBy[this.filterKey][this.filterBy[this.filterKey].indexOf('Absence')]])
            if (this.filterBy[this.filterKey][0] !== undefined) return this.makeList(data[this.filterKey][0][this.filterBy[this.filterKey][0]])
          }
        }

        let objFilters = {}
        for (let filter in lists) {
          let item = lists[filter]
          let key = Object.keys(item)[0]
          let value = item[Object.keys(item)[0]]
          if (typeof value !== 'object') objFilters[key] = value
        }
        return objFilters
      },
      pushDataColumns (val) {
        this.hideOnClick = false
        if (val === undefined) return
        if (this.DataColumn[this.filterKey].indexOf(val) >= 0) this.DataColumn[this.filterKey].splice(this.DataColumn[this.filterKey].indexOf(val), 1)
        else this.DataColumn[this.filterKey].push(val)
      },
      pushCountDataColumns (val) {
        if (val === undefined) return
        if (this.CountDataColumn[this.filterKey].indexOf('Count') < 0) this.CountDataColumn[this.filterKey].push('Count')
        if (this.CountDataColumn[this.filterKey].indexOf(val) >= 0) this.CountDataColumn[this.filterKey].splice(this.CountDataColumn[this.filterKey].indexOf(val), 1)
        else this.CountDataColumn[this.filterKey].push(val)
      },
      pushFilterBy (index, key, method, reset = false, event) {
        if (event === null || event === undefined) return true
        if (reset && event !== this.filters[this.filterKey].minYear) this.filters[this.filterKey].maxYear = null
        if (_.isObject(index)) {
          if (this.runTimeMethod[method](this.filters[this.filterKey][index[0]]) && this.runTimeMethod[method](this.filters[this.filterKey][index[1]]) && this.filterBy[this.filterKey].indexOf(key) < 0) return
          if (!this.runTimeMethod[method](this.filters[this.filterKey][index[0]]) && !this.runTimeMethod[method](this.filters[this.filterKey][index[1]]) && this.filterBy[this.filterKey].indexOf(key) < 0) this.filterBy[this.filterKey].push(key)
          if (this.runTimeMethod[method](this.filters[this.filterKey][index[0]]) && this.runTimeMethod[method](this.filters[this.filterKey][index[1]]) && this.filterBy[this.filterKey].indexOf(key) >= 0) this.filterBy[this.filterKey].splice(this.filterBy[this.filterKey].indexOf(key), 1)
        } else {
          if (_.isUndefined(this.filters[this.filterKey][index])) return
          if (this.runTimeMethod[method](this.filters[this.filterKey][index]) && this.filterBy[this.filterKey].indexOf(key) < 0) return
          if (!this.runTimeMethod[method](this.filters[this.filterKey][index]) && this.filterBy[this.filterKey].indexOf(key) < 0) this.filterBy[this.filterKey].push(key)
          if (this.runTimeMethod[method](this.filters[this.filterKey][index]) && this.filterBy[this.filterKey].indexOf(key) >= 0) this.filterBy[this.filterKey].splice(this.filterBy[this.filterKey].indexOf(key), 1)
        }
        // console.log(this.filters[this.filterKey][index] + ',' + index + ',' + key + ',' + method)
        return
      },
      selectAll () {
        let columns = []
        if (this.SelectAll[this.filterKey]) columns = !this.groupBy[this.filterKey] ? this.makeList(this.dataColumns[this.filterKey], true) : this.makeList(this.countDataColumns[this.filterKey], true, true)
        Vue.set(this.DataColumn, this.filterKey, Object.keys(columns))
        Vue.set(this.SelectAll, this.filterKey, !this.SelectAll[this.filterKey])
      },
      checkIndex (key) {
        if (this.filterBy[this.filterKey] !== undefined && this.filterBy[this.filterKey].indexOf(key) >= 0) return true
        return false
      },
      switchChange () {
        Vue.set(this.SelectAll, this.filterKey, true)
        Vue.set(this.DataColumn, this.filterKey, [])
      },
      dateRangeAccess () {
        if (this.filterBy[this.filterKey].indexOf('DateRange') >= 0 || this.filterBy[this.filterKey].indexOf('Incident') >= 0 || this.filterBy[this.filterKey].indexOf('Violation') >= 0 || this.filterBy[this.filterKey].indexOf('Absence') >= 0) return true
        return false
      },
      resetFiltersValue () {
        if (typeof this.filterBy[this.filterKey] !== 'undefined') {
          switch (this.filterKey) {
            case 'Trip':
              if (this.filterBy[this.filterKey].indexOf('Route') < 0) this.filters[this.filterKey].TourID = null
              if (this.filterBy[this.filterKey].indexOf('Direction') < 0) this.filters[this.filterKey].Direction = null
              if (this.filterBy[this.filterKey].indexOf('DateRange') < 0) this.filters[this.filterKey].dateRange = []
              break
            case 'Bus':
              if (this.filterBy[this.filterKey].indexOf('Capacity') < 0) this.filters[this.filterKey].minCapacity = this.filters[this.filterKey].maxCapacity = null
              if (this.filterBy[this.filterKey].indexOf('ExpirationDate') < 0) this.filters[this.filterKey].date = null
              if (this.filterBy[this.filterKey].indexOf('Year') < 0) this.filters[this.filterKey].minYear = this.filters[this.filterKey].maxYear = null
              break
            case 'Supervisor':
              if (this.filterBy[this.filterKey].indexOf('Nationality') < 0) this.filters[this.filterKey].Nationality = null
              if (this.filterBy[this.filterKey].indexOf('Route') < 0) this.filters[this.filterKey].TourID = null
              if (this.filterBy[this.filterKey].indexOf('Bus') < 0) this.filters[this.filterKey].BusID = null
              if (this.filterBy[this.filterKey].indexOf('DateRange') < 0) this.filters[this.filterKey].dateRange = []
              break
            case 'Driver':
              if (this.filterBy[this.filterKey].indexOf('Nationality') < 0) this.filters[this.filterKey].Nationality = null
              if (this.filterBy[this.filterKey].indexOf('Route') < 0) this.filters[this.filterKey].TourID = null
              if (this.filterBy[this.filterKey].indexOf('Bus') < 0) this.filters[this.filterKey].BusID = null
              if (this.filterBy[this.filterKey].indexOf('DateRange') < 0) this.filters[this.filterKey].dateRange = []
              if (this.filterBy[this.filterKey].indexOf('Violation') < 0) this.filters[this.filterKey].ViolationTypeID = null
              break
            case 'Incident':
              if (this.filterBy[this.filterKey].indexOf('Driver') < 0) this.filters[this.filterKey].BusDriverID = null
              if (this.filterBy[this.filterKey].indexOf('Supervisor') < 0) this.filters[this.filterKey].BusMonitorID = null
              if (this.filterBy[this.filterKey].indexOf('Bus') < 0) this.filters[this.filterKey].BusID = null
              if (this.filterBy[this.filterKey].indexOf('Type') < 0) this.filters[this.filterKey].IncidentTypeID = null
              if (this.filterBy[this.filterKey].indexOf('Type') < 0) this.filters[this.filterKey].IncidentTypeID = null
              if (this.filterBy[this.filterKey].indexOf('Status') < 0) this.filters[this.filterKey].Status = null
              if (this.filterBy[this.filterKey].indexOf('DateRange') < 0) this.filters[this.filterKey].dateRange = []
              break
            case 'Student':
              if (this.filterBy[this.filterKey].indexOf('Absence') < 0) this.filters[this.filterKey].Reason = null
              if (this.filterBy[this.filterKey].indexOf('Address') < 0) { this.filters[this.filterKey].Status = null; this.filters[this.filterKey].radius = 1; this.filters[this.filterKey].longitude = this.filters[this.filterKey].latitude = 0 }
              if (this.filterBy[this.filterKey].indexOf('Bus') < 0) this.filters[this.filterKey].BusID = null
              if (this.filterBy[this.filterKey].indexOf('Grade') < 0) this.filters[this.filterKey].Grade = null
              break
          }
        }
        this.savedQuery[this.filterKey] = JSON.stringify(this.filters[this.filterKey]) + this.dataColumnSerialize()
      },
      dataColumnSerialize () {
        let datacolumn = '&datacolumn='
        for (let key in this.makeList(this.dataColumns[this.filterKey], true)) {
          if (this.DataColumn[this.filterKey].indexOf(key) >= 0) datacolumn += key + '&'
        }
        return datacolumn
      },
      removeIndex (index, ref = false) {
        if (typeof this.filterBy[this.filterKey] === 'string') Vue.set(this.filterBy, this.filterKey, [])
        let passedValue = ref ? index : index.currentValue
        let item = this.filterBy[this.filterKey].indexOf(passedValue)
        this.filterBy[this.filterKey].splice(item, (ref ? 1 : 0))
        this.resetFiltersValue()
      },
      onClickStatus () {
        if (this.filterKey !== null) {
          let dataColumnLength = this.DataColumn[this.filterKey].length
          if (dataColumnLength === 0) return true
          switch (this.filterKey) {
            case 'Trip':
              if (this.filterBy[this.filterKey].length > 0) {
                for (let i = 0; i < this.filterBy[this.filterKey].length; i++) {
                  switch (this.filterBy[this.filterKey][i]) {
                    case 'Route':
                      if (_.isEmpty(this.filters[this.filterKey].TourID)) return true
                      break
                    case 'DateRange':
                      if (!_.isDate(this.filters[this.filterKey].dateRange[0]) && !_.isDate(this.filters[this.filterKey].dateRange[1])) return true
                      break
                    case 'Direction':
                      if (_.isEmpty(this.filters[this.filterKey].Direction)) return true
                      break
                  }
                }
              } else return true
              break
            case 'Bus':
              if (this.filterBy[this.filterKey].length > 0) {
                for (let j = 0; j < this.filterBy[this.filterKey].length; j++) {
                  switch (this.filterBy[this.filterKey][j]) {
                    case 'Capacity':
                      if (_.isEmpty(this.filters[this.filterKey].minCapacity) || _.isEmpty(this.filters[this.filterKey].maxCapacity)) return true
                      break
                    case 'ExpirationDate':
                      if (!_.isDate(this.filters[this.filterKey].date)) return true
                      break
                    case 'Year':
                      if (_.isEmpty(this.filters[this.filterKey].minYear) || _.isEmpty(this.filters[this.filterKey].maxYear)) return true
                      break
                  }
                }
              } else return true
              break
            case 'Supervisor':
            case 'Driver':
              if (this.filterBy[this.filterKey].length > 0) {
                switch (this.filterBy[this.filterKey][0]) {
                  case 'Nationality':
                    if (_.isEmpty(this.filters[this.filterKey].Nationality)) return true
                    break
                  case 'Route':
                    if (_.isEmpty(this.filters[this.filterKey].TourID)) return true
                    break
                  case 'Bus':
                    if (_.isEmpty(this.filters[this.filterKey].BusID)) return true
                    break
                  case 'Incident':
                    if (!_.isDate(this.filters[this.filterKey].dateRange[0]) && !_.isDate(this.filters[this.filterKey].dateRange[1])) return true
                    break
                  case 'Violation':
                    if ((!_.isDate(this.filters[this.filterKey].dateRange[0]) && !_.isDate(this.filters[this.filterKey].dateRange[1])) || this.ViolationTypeID === null) return true
                    break
                }
              }
              break
            case 'Incident':
              if (this.filterBy[this.filterKey].length > 0) {
                for (let k = 0; k < this.filterBy[this.filterKey].length; k++) {
                  switch (this.filterBy[this.filterKey][k]) {
                    case 'Driver':
                      if (_.isEmpty(this.filters[this.filterKey].BusDriverID)) return true
                      break
                    case 'Supervisor':
                      if (_.isEmpty(this.filters[this.filterKey].BusMonitorID)) return true
                      break
                    case 'Bus':
                      if (_.isEmpty(this.filters[this.filterKey].BusID)) return true
                      break
                    case 'Type':
                      if (_.isEmpty(this.filters[this.filterKey].IncidentTypeID)) return true
                      break
                    case 'DateRange':
                      if (!_.isDate(this.filters[this.filterKey].dateRange[0]) && !_.isDate(this.filters[this.filterKey].dateRange[1])) return true
                      break
                    case 'Status':
                      if (_.isEmpty(this.filters[this.filterKey].Status)) return true
                      break
                  }
                }
              } else return true
              break
            case 'Student':
              if (this.filterBy[this.filterKey].length > 0) {
                for (let l = 0; l < this.filterBy[this.filterKey].length; l++) {
                  switch (this.filterBy[this.filterKey][l]) {
                    case 'Date':
                      if (_.isEmpty(this.filters[this.filterKey].dateRange)) return true
                      break
                    case 'Bus':
                      if (_.isEmpty(this.filters[this.filterKey].BusID)) return true
                      break
                    case 'Grade':
                      if (_.isEmpty(this.filters[this.filterKey].Grade)) return true
                      break
                    case 'Absence':
                      if (!_.isDate(this.filters[this.filterKey].dateRange[0]) && !_.isDate(this.filters[this.filterKey].dateRange[1])) return true
                      break
                    case 'Address':
                      if (_.isInteger(this.filters[this.filterKey].longitude) || _.isInteger(this.filters[this.filterKey].latitude)) return true
                      break
                  }
                }
              } else return true
              break
          }
        } else return true
      },
      search () {
        this.checkCommonDataColumns()
        this.hideOnClick = true
        if (!this.groupBy[this.filterKey]) {
          this.filteredCountData[this.filterKey].length = 0
          this.filteredCountData[this.filterKey].splice(0)
        }
        switch (this.filterKey) {
          case 'Trip':
            this.callResource('trip', {
              TourID: this.filters[this.filterKey].TourID,
              dateRange: this.filters[this.filterKey].dateRange,
              Direction: this.filters[this.filterKey].Direction,
              minDate: null,
              maxDate: null
            })
            break
          case 'Bus':
            this.callResource('bus', {
              maxCap: this.filters[this.filterKey].maxCapacity,
              minCap: this.filters[this.filterKey].minCapacity,
              maxYear: this.filters[this.filterKey].maxYear,
              minYear: this.filters[this.filterKey].minYear,
              date: this.filters[this.filterKey].date,
              ExpirationDate: null
            })
            break
          case 'Supervisor':
          case 'Driver':
            this.callResource('staff', {
              TourID: this.filters[this.filterKey].TourID,
              BusID: this.filters[this.filterKey].BusID,
              ViolationTypeID: this.filters[this.filterKey].ViolationTypeID,
              dateRange: this.filters[this.filterKey].dateRange,
              minDate: null,
              maxDate: null,
              Nationality: this.filters[this.filterKey].Nationality,
              staff: this.filterKey
            })
            break
          case 'Incident':
            this.callResource('incident', {
              DiverID: this.filters[this.filterKey].BusDriverID,
              MonitorID: this.filters[this.filterKey].BusMonitorID,
              BusID: this.filters[this.filterKey].BusID,
              IncidentTypeID: this.filters[this.filterKey].IncidentTypeID,
              Status: this.filters[this.filterKey].Status,
              dateRange: this.filters[this.filterKey].dateRange,
              minDate: null,
              maxDate: null
            })
            break
          case 'Student':
            this.callResource('student', {
              BusID: this.filters[this.filterKey].BusID,
              longitude: this.filters[this.filterKey].longitude,
              latitude: this.filters[this.filterKey].latitude,
              radius: this.filters[this.filterKey].radius,
              Class: this.filters[this.filterKey].Class,
              Grade: this.filters[this.filterKey].Grade,
              Reason: this.filters[this.filterKey].Reason,
              requestedFor: 'Single',
              dateRange: this.filters[this.filterKey].dateRange,
              minDate: null,
              maxDate: null
            })
            break
        }
      },
      callResource (endPoint, data) {
        data.filtersBy = this.filterBy[this.filterKey]
        data.DataColumn = this.DataColumn[this.filterKey]
        data.groupBy = this.groupBy[this.filterKey]
        data.limit = this.limit[this.filterKey]
        data.offset = this.limit[this.filterKey] * (this.currentPage[this.filterKey] - 1)
        this.loading = true
        if (!_.isEmpty(data.dateRange)) {
          if (!_.isNull(data.dateRange[0])) data.minDate = this.$moment(data.dateRange[0]).format('YYYY-MM-DD')
          if (!_.isNull(data.dateRange[1])) data.maxDate = this.$moment(data.dateRange[1]).format('YYYY-MM-DD')
          delete data.dateRange
        }
        if (_.isDate(data.date)) {
          data.ExpirationDate = this.$moment(data.date).format('YYYY-MM-DD')
          delete data.date
        }
        let self = this
        this.$http.get('/report/' + endPoint + '?' + qs.stringify(data))
          .then(function (response) {
            self.total[self.filterKey] = response.data.total
            Vue.set((!self.groupBy[self.filterKey] ? self.filteredData[self.filterKey] : self.filteredCountData[self.filterKey]), self.currentPage[self.filterKey] - 1, response.data.data)
            if (self.filteredCountData[self.filterKey].length === 0) {
              self.CountDataColumn[self.filterKey].length = 0
              self.CountDataColumn[self.filterKey].splice(0)
            }
            self.sortOrders = {}
            self.loading = false
            let savedQuery = 'savedQuery' + self.filterKey
            localStorage.setItem(savedQuery, JSON.stringify(self.filters[self.filterKey]) + self.dataColumnSerialize())
            Vue.set(self.opacity, self.filterKey, 1)
          })
          .catch(function (error) {
            self.loading = false
            console.log(error)
          })
      },
      checkCommonDataColumns () {
        let loadedColumns = !this.groupBy[this.filterKey] ? this.makeList(this.dataColumns[this.filterKey], true) : this.makeList(this.countDataColumns[this.filterKey], true, true)
        let newColumns = []
        for (let i = 0; i < this.DataColumn[this.filterKey].length; i++) {
          if (Object.prototype.hasOwnProperty.call(loadedColumns, this.DataColumn[this.filterKey][i])) newColumns.push(this.DataColumn[this.filterKey][i])
        }
        Vue.set(this.DataColumn, this.filterKey, newColumns)
      },
      uniqueColumnsCount () {
        let el = this.$refs.countsBy.$el
        this.$nextTick(() => {
          setTimeout(() => { el.style.width = Math.max(220, el.firstChild.firstChild.offsetWidth + 34) + 'px' }, 20)
        })
        let sub = {}
        if (this.filteredData[this.filterKey][this.currentPage[this.filterKey] - 1].length !== 0 && this.CountDataColumn[this.filterKey].length !== 0) {
          for (let i = 0; i < this.filteredData[this.filterKey][this.currentPage[this.filterKey] - 1].length; i++) {
            let value = ''
            for (let index in this.CountDataColumn[this.filterKey]) {
              value += this.filteredData[this.filterKey][this.currentPage[this.filterKey] - 1][i][this.CountDataColumn[this.filterKey][index]]
            }
            if (sub[value] === undefined) sub[value] = {Count: 0}
            for (let index in this.CountDataColumn[this.filterKey]) {
              let column = this.CountDataColumn[this.filterKey][index]
              if (sub[value][column] === undefined) sub[value][column] = this.filteredData[this.filterKey][this.currentPage[this.filterKey] - 1][i][column]
            }
            if (sub[value] !== undefined) sub[value].Count += 1
          }
        }
        let subArray = Object.keys(sub).map(function (key) { return sub[key] })
        Vue.set(this.filteredCountData[this.filterKey], this.currentPage[this.filterKey] - 1, subArray)
      },
      pick (o, fields) {
        let objFilters = {}
        for (let key in o) {
          if (typeof o[key] !== 'object') {
            if (fields.indexOf(key) >= 0) objFilters[key] = o[key]
          }
        }
        return objFilters
      },
      changeFilterKey (tab, event) {
        this.filterKey = tab.name
      },
      range (start, stop, step) {
        if (typeof stop === 'undefined') {
          stop = start
          start = 0
        }
        if (typeof step === 'undefined') {
          step = 1
        }
        if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
          return []
        }
        let result = []
        for (let i = start; step > 0 ? i < stop : i > stop; i += step) {
          result.push(i.toString())
        }
        return result
      },
      handleGroupedOption (comp) {
        let filterBy = []
        let neighbourLabelIndex = (comp.$parent.label === this.$t('SELECTMULTIPLE')) ? 0 : 1
        if (comp.$parent.label === this.$t('SELECTMULTIPLE')) comp.$parent.$children.forEach(function (item) { if (item.itemSelected) return filterBy.push(item.value) })
        comp.$parent.$parent.$children[neighbourLabelIndex].$children.forEach(function (item) { if (item.itemSelected) return filterBy.push(item.value) })
        if (comp.itemSelected) filterBy.splice(filterBy.indexOf(comp.value), 1)
        else filterBy.push(comp.value)
        if (comp.$parent.label === this.$t('SELECTONE')) {
          for (let multicomp of this.multiSelectComponents) {
            this.removeTag(multicomp)
          }
          this.multiSelectComponents = []
          if (this.singleSelectComponent !== null) this.removeTag(this.singleSelectComponent)
          this.singleSelectComponent = comp
        }
        if (comp.$parent.label === this.$t('SELECTMULTIPLE')) {
          if (this.singleSelectComponent !== null) {
            this.removeTag(this.singleSelectComponent)
            this.singleSelectComponent = null
          }
          this.multiSelectComponents.push(comp)
        }
        Vue.set(this.filterBy, this.filterKey, filterBy)
      },
      removeTag (comp) {
        this.filterBy[this.filterKey].splice(this.filterBy[this.filterKey].indexOf(comp.value), 1)
      },
      getDynamicSpan () {
        let columns = this.filterBy[this.filterKey].length
        if (this.filterBy[this.filterKey].length === 1) columns = 2
        return 24 / columns
      },
      checkAllConditions () {
        if ((this.filteredData[this.filterKey].length !== 0 || this.filteredCountData[this.filterKey].length !== 0) && (this.DataColumn[this.filterKey].length !== 0 || this.CountDataColumn[this.filterKey].length !== 0)) return true
        return false
      },
      exportToCSV () {
        let items = this.makeList(this.dataColumns[this.filterKey], true)
        let columns = {}
        for (let item in items) {
          if (this.DataColumn[this.filterKey].indexOf(item) >= 0) columns[item] = items[item]
        }
        let self = this
        this.$http.post('/report/export', qs.stringify({data: (this.filteredCountData[this.filterKey][this.currentPage[this.filterKey] - 1].length === 0) ? this.filteredData[this.filterKey][this.currentPage[this.filterKey] - 1] : this.filteredCountData[this.filterKey][this.currentPage[this.filterKey] - 1], columns: columns, count: (this.filteredCountData[this.filterKey][this.currentPage[this.filterKey] - 1].length === 0)}))
          .then(function (response) {
            window.location = self.BASEURL + response.data.file_path
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      absenceGroupByColumns (obj) {
        let prevents = ['Nationality', 'Gender']
        let selected = {}
        for (let key in obj) {
          if (prevents.indexOf(key) < 0) selected[key] = obj[key]
        }
        return selected
      },
      setPlace (place) {
        this.Location = place.formatted_address
        this.filters[this.filterKey].longitude = place.geometry.location.lng()
        this.filters[this.filterKey].latitude = place.geometry.location.lat()
      },
      handleSizeChange (val) {
        this.limit[this.filterKey] = val
        this.filteredData[this.filterKey].length = this.filteredCountData[this.filterKey].length = 0
        this.currentPage[this.filterKey] = 1
        this.visitedPage[this.filterKey] = []
        this.search()
      },
      clearEmirate (filterKey) {
        this.show[filterKey].zone = false
        this.show[filterKey].sector = false
        this.show[filterKey].others = true
        this.filters[filterKey].zone = null
        this.filters[filterKey].sector = null
      },
      clearZone (filterKey) {
        this.show[filterKey].zone = false
        this.show[filterKey].sector = false
        this.show[filterKey].others = true
        this.filters[filterKey].emirate = null
        this.filters[filterKey].sector = null
      },
      clearSector (filterKey) {
        this.show[filterKey].sector = false
        this.filters[filterKey].zone = null
      },
      handleEmirateChange (filterKey) {
        this.show[filterKey].zone = true
        this.show[filterKey].others = false
      },
      handleZoneChange (filterKey) {
        this.show[filterKey].sector = true
      }
    }
  }
</script>

<style>
    #report .el-select{display: block}
    #report .el-tabs__header{position: inherit}
    #report .pull-right{float: right}
    #report .pull-left{float: left}
    #report .group{display: flex;}

    
    #report .group .first-radius input{border-bottom-left-radius: inherit;border-top-left-radius: inherit;}
    #report .first-radius{border-bottom-left-radius: inherit;border-top-left-radius: inherit;}
    #report .second-radius{border-bottom-right-radius: inherit;border-top-right-radius: inherit;}
    
    #rtl #report .group .second-radius input{border-bottom-left-radius: inherit;border-top-left-radius: inherit;}
    #rtl #report .second-radius{border-bottom-left-radius: inherit;border-top-left-radius: inherit;}
    #rtl #report .first-radius{border-bottom-right-radius: inherit;border-top-right-radius: inherit;}
    #report .group .second-radius input{border-bottom-left-radius: inherit;border-top-left-radius: inherit;}
    #report .el-tabs--border-card >.el-tabs__content{padding: 0px !important;position: inherit;}
    #report .el-tabs__nav{float: none}
    #report .filters{padding: 10px !important;border-bottom: 1px solid rgb(209, 219, 229);border-bottom: 1px solid rgb(209, 219, 229);}
    #report .filters .el-form-item {margin-bottom: 0px;}
    #report .autoWidth {display: inline-block;}
    #report .autoWidth .el-select__tags{white-space:nowrap}
    #report .footer {padding: 7px 15px}
    #report .el-switch {width: 100%;}
    #report .el-switch__core {width: 100%;}
    #report .el-date-editor.el-input {width: 100%;}
    #report .loading-z-index {z-index: 2000}
    #report .el-input-group__prepend.buses{width: 50%;}
    #report .el-input-group__prepend.buses > .el-select{width: unset;}
    #report .el-input-group__prepend.buses > .el-input{display: block;margin: -12px;width: unset;}
    #report .el-input-group__prepend.buses > .need-radius.el-input input{border-top-left-radius: 4px;border-bottom-left-radius: 4px;}
    #rtl #report .el-input-group__prepend.buses > .need-radius.el-input input{border-top-right-radius: 4px;border-bottom-right-radius: 4px;}

</style>



// WEBPACK FOOTER //
// Report.vue?f11f6d7a